import { withFormik } from "formik";
import * as Yup from "yup";

const EmailRegEx = /\S+@\S+\.\S+/;

const formikEnhancer = withFormik({
  validationSchema: Yup.object().shape({
    email: Yup.string()
      .matches(EmailRegEx, "Please enter valid Email")
      .required("Please Enter Any Email"),
    password: Yup.string().required("Please Enter Any Password")
  }),
  mapPropsToValues: props => ({
    email: "",
    password: ""
  }),
  handleSubmit: values => {},
  displayName: "CustomValidationForm",
  enableReinitialize: true
});

export default formikEnhancer;
